import { AxiosError } from 'axios';
import FeatherIcon from 'feather-icons-react';
import { FormEventHandler, useState } from 'react';
import { Col, Form, InputGroup, Row, Toast, ToastContainer } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import SubmitButton from '../components/Buttons/SubmitButton';
import { DEFAULT_ERROR_MESSAGE } from '../consts';
import { isEmptyPassword, isValidEmail } from '../helpers/validation';
import { landingPathFor } from '../permissions';
import { loginUser } from '../store/redux/userRedux';
import api from '../utils/api';
import { TOKEN_KEY } from '../utils/tenant';

const SignInForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };

  const loginHandler: FormEventHandler = async e => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = await api('post', '/auth/login', {
        email,
        password
      });

      setLoading(false);
      dispatch(loginUser(data));
      localStorage.setItem(TOKEN_KEY, data.token);
      navigate(landingPathFor(data.role));
    } catch (error) {
      setLoading(false);
      error instanceof AxiosError ? setError(error.response?.data?.message) : setError(DEFAULT_ERROR_MESSAGE);
      setTimeout(() => {
        setError('');
      }, 3000);
    }
  };

  return (
    <>
      <h1 className="display-4 text-center mb-3">Sign in</h1>
      <p className="text-muted text-center mb-5">Warehouse management application.</p>
      <form onSubmit={loginHandler}>
        <div className="form-group">
          <Form.Label htmlFor="email">Email Address</Form.Label>
          <Form.Control
            type="email"
            id="email"
            placeholder="name@address.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            isValid={isValidEmail(email)}
          />
        </div>
        <div className="form-group">
          <Row>
            <Col>
              <Form.Label htmlFor="password">Password</Form.Label>
            </Col>
            {/*<Col xs="auto">
              <Form.Text as={Link} className="small text-muted" to="/password-reset">
                Forgot password?
              </Form.Text>
            </Col>*/}
          </Row>
          <InputGroup className="input-group-merge">
            <Form.Control
              type={`${passwordShown ? 'text' : 'password'}`}
              id="password"
              placeholder="Enter your password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              isValid={!isEmptyPassword(password)}
            />
            <InputGroup.Text onClick={togglePasswordVisibility}>
              <FeatherIcon icon={`${passwordShown ? 'eye-off' : 'eye'}`} size="1em" />
            </InputGroup.Text>
          </InputGroup>
        </div>
        <SubmitButton
          disabled={isEmptyPassword(password) || !isValidEmail(email)}
          loading={loading}
          buttonText="Sign In"
          type="submit"
        ></SubmitButton>

        {error && (
          <ToastContainer position="bottom-center" className="p-3">
            <Toast bg="danger">
              <Toast.Body className="text-white">{error}</Toast.Body>
            </Toast>
          </ToastContainer>
        )}
      </form>
    </>
  );
};

export default SignInForm;
